import { Component, OnInit,ViewChild, ViewEncapsulation } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import {MatTableDataSource} from '@angular/material/table';
import { NotifierService } from 'angular-notifier';
import { MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import{ ConfirmListadoIniciativasAdminComponent} from 'src/app/components/shared/confirm-listado-iniciativas-admin/confirm-listado-iniciativas-admin.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import * as moment from 'moment';



export interface Periodos {
  id_periodoEnvio: number;
  fechaInicio_periodoEnvio: string;
  fechaTermino_periodoEnvio: string
}


@Component({
  selector: 'app-periodos-envio',
  templateUrl: './periodos-envio.component.html',
  styleUrls: ['./periodos-envio.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class PeriodosEnvioComponent implements OnInit {
  //Lista para los periodos de envio
  listaPeriodo: Periodos[]=[];
  secondFormGroup: FormGroup;
  displayedColumns: string[] = ['inicio', 'fin', 'Acciones'];
  dataSource:any;
  botonPresionado:number;
  loadingGeneral: boolean = true;
  diasDisponibles = [];
  minDate: Date = new Date();
  maxDate: Date;
  dia;
  startDate:Date;
  fi1
  ff1

  @ViewChild('TablaPeriodo', {static: false}) paginator: MatPaginator;



  constructor(private dataService: DataService,
    public dialog:MatDialog,
    private _fb: FormBuilder,
    private notifier: NotifierService) {
      this.cargarPeriodosEnvio();
     }

  ngOnInit(): void {
    //Cargamos la lista de los periodos
    this.secondFormGroup = this._fb.group({
      dia: ['', Validators.required]
    });
  }

  //Método para aplicar el filtro 
 applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

  cargarPeriodosEnvio()
  {
    this.loadingGeneral = true;
    this.dataService.getListPeriodosEnvio().subscribe(
      async (data) => {
        this.listaPeriodo = data['data'];
       
        this.dataSource = new MatTableDataSource(this.listaPeriodo);
        this.dataSource.paginator=this.paginator;
        this.loadingGeneral = false;
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para las acciones de la tabla de periodos
  onSubmitReactive(btnId:number, id_periodo:number,){
    this.botonPresionado=btnId;

    //Opcion de Agregar
    if(this.botonPresionado==1)
    {
       this.agregarPeriodo();
    }

    //Opcion de Editar
    if(this.botonPresionado==2)
    {
       this.editarPeriodo(id_periodo);
    }

    //Opcion de Eliminar
    if(this.botonPresionado==3)
    {
       this.eliminarPeriodo(id_periodo);
    }


  }



/*   dateClass:MatCalendarCellClassFunction<Date> = async (cellDate, view) => {
    const date = cellDate.getDate();
    console.log(date);
    const timer = setTimeout(async () => {
      console.log(await this.fi1);
      console.log(await this.ff1);
       return 'directoresArea';
    }, 500);
    return '';
  } */






  reformatDate(date){
    let d = date.split("-");
    let dd1=d[2];
    let p = dd1.split("T");
    let dd=p[0];
    let mm=d[1]-1;
    let yyyy =d[0];
    let newDate=new Date(yyyy,mm,dd);
    return newDate;
  }

  //Método para eliminar la iniciativa
  eliminarPeriodo(id_periodo:number)
  {
    //Mostramos la ventana de confirmación
      let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id_periodo:id_periodo,opcion:12},disableClose:true});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
         this.botonPresionado=0;
        }
        else{
         this.dataService.deletePeriodoEnvio(id_periodo).subscribe(
           data => {
             if (data['objData']) 
             {
               this.notifier.notify(
                 'success',
                 'Se elimino correctamente.'
               );
               this.cargarPeriodosEnvio();
             }
             else{
               this.notifier.notify('error',data['errorMessage']);
                
             }
           },
           error => {
             console.error(error);
             this.notifier.notify(
               'error',
               'Ha ocurrido un error al intentar eliminar el periodo. Verifique su conexión de red o contacte al administrador.'
             );
           }
         );

         this.botonPresionado=0;
        }
    }); 
  }

  //Agregar periodo
  agregarPeriodo()
 { 
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{opcion:13, titulo:"Agregar periodo"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
       this.botonPresionado=0;
      }
      else{
       this.dataService.addPeriodoEnvio(result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se agrego correctamente.'
             );
             this.cargarPeriodosEnvio()
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar agregar el periodo. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );
       this.botonPresionado=0;
      }
  }); 
}

//Método para editar periodo
editarPeriodo(id_periodo:number)
{
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id_periodo:id_periodo,opcion:14,titulo:"Editar periodo"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
       this.botonPresionado=0;
      }
      else{
       this.dataService.updatePeriodoEnvio(id_periodo,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarPeriodosEnvio();
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
              
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar el periodo. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

       this.botonPresionado=0;
      }
  }); 

}

}
